import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { api } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      await api.post("/auth/password-reset/request", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      // Endpoint always returns 200 — any error here is a network issue.
      console.error("[ForgotPassword] request failed", err);
      setSent(true); // still show generic success to avoid enumeration hints
    } finally { setSubmitting(false); }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-screen bg-tb-navy-deep text-tb-cream flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white text-tb-navy rounded-2xl border-2 border-tb-gold shadow-2xl p-8">
        <Link to="/auth" className="inline-flex items-center gap-1 text-tb-navy/60 font-hand text-sm mb-4 hover:text-tb-navy">
          <ArrowLeft className="w-4 h-4" /> back to sign in
        </Link>
        <h1 className="font-serif-it text-3xl mb-2">Forgot your password?</h1>
        <p className="font-hand text-tb-navy/70 mb-6">
          Enter your email and we'll send you a link to reset it. The link expires in 1 hour.
        </p>
        {sent ? (
          <div data-testid="forgot-password-sent" className="p-4 rounded-lg bg-tb-cream-2 border-2 border-tb-cream-3">
            <div className="flex items-center gap-2 font-serif-it text-lg text-tb-navy">
              <Mail className="w-5 h-5 text-tb-gold" />
              Check your inbox
            </div>
            <p className="font-hand text-tb-navy/70 mt-2 text-sm">
              If an account with that email exists, we've sent a reset link. It expires in 1 hour.
            </p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <label className="block">
              <span className="block font-hand text-tb-navy/70 text-sm mb-1">Email</span>
              <input
                data-testid="forgot-password-email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="w-full px-3 py-2 rounded-lg bg-white border-2 border-tb-cream-3 focus:border-tb-gold outline-none font-ui text-sm"
              />
            </label>
            <button
              data-testid="forgot-password-submit"
              type="submit"
              disabled={submitting}
              className="w-full py-2 rounded-full bg-tb-navy text-tb-gold-bright border-2 border-tb-gold font-hand disabled:opacity-50"
            >
              {submitting ? "sending…" : "send reset link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
